import {Setting} from "./Setting";

export const militarySetting: Setting = {
    key: "Military",
    title: "Военное дело",
    description: `Военное дело охватывает все аспекты, связанные с организацией, стратегией, тактикой, технологиями и политикой, касающимися войны и боевых действий. Оно определяет, как проходят военные конфликты, какие структуры армии существуют, как игроки могут участвовать в войнах и как эта сфера влияет на общий мир.`,
    components: [
        {
            title: "Военные структуры и организации",
            subComponents: [
                {
                    title: "Армии",
                    description: `Основные военные силы, состоящие из солдат, офицеров, полков и дивизий, которые могут быть организованы по различным стандартам (например, по профессии, магическим способностям или использованию технологий).`,
                    examples: ["Императорская армия, состоящая из пехоты, кавалерии и магов."]
                },
                {
                    title: "Частные военные компании",
                    description: `Независимые группы наемников, предоставляющие военные услуги за плату. Они могут действовать на стороне государств или против них.`,
                    examples: ["Гильдия наемников, работающая на контрактах по всему миру."]
                },
                {
                    title: "Фракции и альянсы",
                    description: `Военные альянсы, которые могут заключать договоры, поддерживать друг друга в конфликте или разделять ресурсы для ведения войны.`,
                    examples: ["Союз королевств для защиты от нашествия демонов.", "Политический блок стран против диктаторского режима."]
                },
                {
                    title: "Наемники",
                    description: `Индивидуальные или групповые воины, нанимающиеся для выполнения военных операций за деньги или другие ресурсы. Их лояльность может зависеть от условий контракта.`,
                    examples: ["Убийцы, работающие на заказ в тени."]
                }
            ]
        },
        {
            title: "Тактика и стратегия",
            subComponents: [
                {
                    title: "Оборона и осады",
                    description: `Применение оборонительных сооружений, укреплений, цитаделей, замков и стен для защиты от вражеских войск. Тактики осад включают использование осадных машин, магии или альтернативных методов.`,
                    examples: ["Оборона замка от орков и троллей.", "Осада вражеского города для захвата его ресурсов."]
                },
                {
                    title: "Тактика боя",
                    description: `Стратегия на поле боя, включая использование пехоты, кавалерии, артиллерии, магии и так далее. Также важно планирование атак, маневров и ловушек.`,
                    examples: ["Сражение на открытом поле между двумя армиями."]
                },
                {
                    title: "Ресурсы и снабжение",
                    description: `Важность организации снабжения войск — еда, оружие, аммуниция и медикаменты. Без этого армия может стать уязвимой даже в выигрывающей позиции.`,
                    examples: ["Блокада города для истощения его ресурсов.", "Захват складов для укрепления своей позиции."]
                },
                {
                    title: "Шпионаж и разведка",
                    description: `Использование разведчиков и шпионов для получения информации о вражеских силах и планах, а также проведения диверсий.`,
                    examples: ["Подрыв вражеских оборонительных сооружений.", "Получение секретной информации о планах врага."]
                }]
        },
        {
            title: "Оружие и техника",
            subComponents: [
                {
                    title: "Оружие",
                    description: `Мечи, луки, копья, огнестрельное оружие, магия и другие средства борьбы, такие как ядовитые вещества или устройства для поражения врага.`,
                    examples: ["Магический посох, способный вызывать огонь.", "Арбалет с ядовитыми болтами."]
                },
                {
                    title: "Боевые машины",
                    description: `Осадные орудия, такие как катапульты, требушеты, осадные башни, а также более современные или магические машины, если это соответствует сеттингу игры.`,
                    examples: ["Огнемет, способный сжигать врагов.", "Магический кристалл, создающий силовое поле."]
                },
                {
                    title: "Силовые поля и броня",
                    description: `В сеттингах с магией или высокими технологиями могут использоваться силовые поля, щиты, броня с улучшенными защитными характеристиками и другие средства защиты.`,
                    examples: ["Энергетический щит, отражающий атаки.", "Броня, усиленная магическими рунами."]
                },
                {
                    title: "Магическое оружие",
                    description: `В играх с элементами фэнтези или магии могут быть использованы артефакты, волшебные посохи, заклинания и другие средства для усиления армии.`,
                    examples: ["Меч, способный разрушать противников магией.", "Амулет, призывающий духов для помощи."]
                }]
        },
        {
            title: "Боевые действия",
            subComponents: [
                {
                    title: "Конфликты",
                    description: `Военные действия могут быть локальными (например, сражение за одно поселение) или глобальными (война между великими государствами или цивилизациями).`,
                    examples: ["Битва за замок, решающая судьбу королевства.", "Мировая война за контроль над ресурсами."]
                },
                {
                    title: "Морская война",
                    description: `Военные действия на море с использованием кораблей, подводных лодок, воздушных судов и морской магии.`,
                    examples: ["Морской бой между флотами двух стран.", "Поиск сокровищ на дне океана."]
                },
                {
                    title: "Воздушные сражения",
                    description: `В сеттингах с высокими технологиями или магией могут происходить битвы с использованием летательных аппаратов или магических существ, таких как драконы.`,
                    examples: ["Воздушная дуэль на магических драконах.", "Бомбардировка вражеских позиций с воздушных кораблей."]
                },
                {
                    title: "Генералы и командование",
                    description: `Роль лидеров в армии, таких как командующие, генералы и другие важные фигуры, которые планируют и осуществляют стратегии. Игроки могут сами возглавить армию или быть частью штаба.`,
                    examples: ["Героический генерал, ведущий своих войск в бой.", "Командующий, принимающий решения на поле боя."]
                }]
        },
        {
            title: "Последствия войны",
            subComponents: [
                {
                    title: "Мораль",
                    description: `Война влияет на мораль населения и армии. Усталость, смерть, разрушения могут вызывать падение морального духа как среди солдат, так и среди граждан.`,
                    examples: ["Бунт солдат из-за тяжелых условий.", "Поддержка граждан во время войны."]
                },
                {
                    title: "Экономические последствия",
                    description: `Война истощает ресурсы, может вызвать инфляцию, дефицит товаров и ухудшение жизненного уровня. Возможно, потребуется вводить жесткую экономическую политику или введение военного положения.`,
                    examples: ["Разрушение фабрик и заводов во время боевых действий.", "Увеличение налогов для финансирования войны."]
                },
                {
                    title: "Политические последствия",
                    description: `Победа или поражение в войне может изменить политическую карту мира, привести к революциям или смене правителей.`,
                    examples: ["Смена правительства после поражения в войне.", "Разделение территорий между победителями."]
                }]
        }
    ],
    prompt: {
        component: {
            list: 'Перечисли возможные компоненты военного дела и опиши их если они применимы к истории. Не ограничивайся основными компонентами если необходимо',
            single: 'Сгенерируй компонент военного дела для мира. Опиши ключевые аспекты, структуры и последствия военных действий.',
            extend: 'Дополни описание компонента военного дела и разбей на абзацы. Как компонент влияет на мир и персонажей.'
        },
        element: {
            list: 'Перечисли возможные элементы военного дела и опиши их если они применимы к истории',
            single: 'Сгенерируй элемент военного дела для мира. Опиши ключевые аспекты, структуры и последствия военных действий.',
            extend: 'Дополни описание элемента военного дела и разбей на абзацы. Как элемент влияет на мир и персонажей.'
        },
        lore: {
            list: "Создай элементы лора на основе этого элемента военного дела. Его историю, мифы, влияние на мир и персонажей",
            single: "Создай элементы лора на основе этого элемента военного дела. Опиши что-то одно, например: историю, мифы, влияние на мир и персонажей",
            extend: "Дополни описание элемента лора военного дела и разбей на абзацы."
        }
    }
}